import { render, staticRenderFns } from "./partnerDetail.vue?vue&type=template&id=f3f1aa7e&scoped=true"
import script from "./partnerDetail.vue?vue&type=script&lang=js"
export * from "./partnerDetail.vue?vue&type=script&lang=js"
import style0 from "./partnerDetail.vue?vue&type=style&index=0&id=f3f1aa7e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3f1aa7e",
  null
  
)

export default component.exports